// Multi-layer rights envelope (v1). The layer *structure* comes from the Plan
// Stack roles; the *quantities* are entered by the professional (modifier
// plans' additive rights can't be extracted reliably). Modifier additions are
// vested and join the envelope; potential/influence additions are tallied
// separately and never presented as vested rights.
import { PLAN_ROLE } from '../state/model';

const LAYER_ROLES = [
  PLAN_ROLE.MAIN_RIGHTS,
  PLAN_ROLE.MODIFIER,
  PLAN_ROLE.POTENTIAL_CEILING,
  PLAN_ROLE.INFLUENCE,
];

const additionOf = (item) => {
  const v = Number(item.rightsAddition?.value);
  return Number.isFinite(v) && v > 0 ? v : 0;
};

export function isVestedLayerRole(role) {
  return role === PLAN_ROLE.MODIFIER;
}

export function computeLayers(project, metrics) {
  const allowedTotal = metrics.find((m) => m.key === 'allowedTotal');
  const existing = metrics.find((m) => m.key === 'existingArea');

  const layers = (project.planStack || []).filter((it) => LAYER_ROLES.includes(it.role.value));
  const vestedAdd = layers.filter((it) => isVestedLayerRole(it.role.value)).reduce((s, it) => s + additionOf(it), 0);
  const potentialAdd = layers
    .filter((it) => [PLAN_ROLE.POTENTIAL_CEILING, PLAN_ROLE.INFLUENCE].includes(it.role.value))
    .reduce((s, it) => s + additionOf(it), 0);

  const base = allowedTotal.status === 'ok' ? allowedTotal.value : null;
  const existingVal = existing.status === 'ok' ? existing.value : null;

  return {
    layers,
    base,
    vestedAdd,
    potentialAdd,
    vestedFull: base != null ? base + vestedAdd : null,
    remainingFull: base != null && existingVal != null ? base + vestedAdd - existingVal : null,
    existing: existingVal,
  };
}
